import { Button, Form, List, Select } from "antd";
import { useEffect, useState } from "react";
import { complexDigitToman } from "../../../../tools/tools";
import { useDealer } from "../../../../tools/api";
import { NotFound } from "../../../../sources/svg/svg";
import { switchPlanID } from "../../../../tools/services";
import { PackageFeatures, PackageTypeTag } from "../packageInfo";

// discount shown on the card when the old price is higher than the current one
const offPercent = (p) => {
	const before = Number(p.showBeforePrice) || 0;
	const now = Number(p.packagePrice) || 0;
	return before > now ? Math.round((1 - now / before) * 100) : 0;
};

// picking a card selects it; its button (or the summary) then continues to the pre-invoice
const Packages = ({ categoryList = [], packagesList = [], selected, onSelect, onContinue }) => {
	const { queryPackagesBySubGroup } = useDealer();
	const [packages, setPackages] = useState([]);
	const [categories, setCategories] = useState([]);
	const [chooseOption, setChooseOption] = useState();
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		setPackages(packagesList);
		setCategories(categoryList);
	}, [packagesList]);

	const handleChange = async (value, option) => {
		setIsLoading(true);
		setChooseOption(value);
		let payload = {
			subproductgroupid: value,
			planid: switchPlanID().extraPackage,
		};
		let response = await queryPackagesBySubGroup(payload);
		if (response) {
			setPackages(response);
		}
		setIsLoading(false);
	};
	return (
		<>
			<div className="packages-list-show">
				<div className="show-type-filter">
					<Form layout="vertical" className="filter-grid">
						{categories.map((item, key) => (
							<Form.Item className="input-normal" label={item.productGroupName} key={key}>
								<Select
									placeholder="همه"
									onChange={handleChange}
									value={item.subgroup.filter((sitem) => sitem.inT_ProductSubGroupId === chooseOption)?.length > 0 ? chooseOption : undefined}>
									{item.subgroup.map((sItem, sKey) => (
										<Select.Option key={sKey} value={sItem.inT_ProductSubGroupId} category={item.productGroupId}>
											{sItem.stR_ProductSubGroupName}
										</Select.Option>
									))}
								</Select>
							</Form.Item>
						))}
					</Form>
				</div>
				<div className="show-packages">
					<List
						itemLayout="horizontal"
						dataSource={packages}
						loading={isLoading}
						locale={{ emptyText: <NotFound text={""} /> }}
						renderItem={(item, key) => (
							<div
								className={`pkg-card${selected?.packageId === item.packageId ? " selected" : ""}`}
								key={key}
								role="button"
								tabIndex={0}
								onClick={() => onSelect(item)}
								onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onSelect(item)}>
								{offPercent(item) > 0 && <span className="pkg-off">{offPercent(item)}٪ تخفیف</span>}
								<div className="pkg-head">
									<span className="pkg-tag">
										<PackageTypeTag pkg={item} />
									</span>
									<span className="pkg-billing">{item.packageBillingType === "0" ? <>اعتباری</> : <>دائمی</>}</span>
								</div>
								<h3>{item.packageName}</h3>
								<p>
									<PackageFeatures pkg={item} />
								</p>
								<div className="pkg-foot">
									<div className="pkg-price">
										{item.showBeforePrice != 0 && (
											<span className="old" dir="ltr">
												{complexDigitToman(item.showBeforePrice)}
											</span>
										)}
										<span className="new">
											<span dir="ltr">{complexDigitToman(item.packagePrice)}</span> <small>تومان</small>
										</span>
									</div>
									{selected?.packageId === item.packageId ? (
										<Button
											htmlType="button"
											tabIndex={-1}
											onClick={(e) => {
												e.stopPropagation();
												onContinue();
											}}>
											ادامه ←
										</Button>
									) : (
										<Button htmlType="button" tabIndex={-1} data-object={JSON.stringify(item)}>
											انتخاب
										</Button>
									)}
								</div>
							</div>
						)}
					/>
				</div>
			</div>
		</>
	);
};

export default Packages;
